import Widget from './Widget.svelte';

let app;

declare global {
  interface Window { talkvisorWidget: ShadowRoot | undefined; }
}

function loadWidget() {
  // If it's somehow already rendered, return early.
  if (window.talkvisorWidget !== undefined) return;

  const widget = document.createElement('div');
  widget.setAttribute('id', 'talkvisor-widget');
  widget.setAttribute('style', 'display: block !important;');
  document.body.appendChild(widget);

  // Create a shadow DOM with scoped css.
  const shadow = widget.attachShadow({ mode: "open" });
  window.talkvisorWidget = shadow; // Make this globally addressable.

  // Render everything under this shadow DOM so the store's CSS won't affect our widget.
  app = new Widget({ target: window.talkvisorWidget, props: {} });
}

loadWidget();

export default app;
